module.exports = __webpack_public_path__ + "static/media/calendar.54b359e0.svg";